export default {
  businessLogisticsCompanyMapping: {
    header: {
      thirdPartyEncoding: '第三方编码',
      thirdPartyLogisticsName: '第三方物流名称',
      platformName: '平台名称'
    },
    table: {
      businessName: '业务名称',
      thirdPartyEncoding: '第三方编码',
      thirdPartyLogisticsName: '第三方物流名称',
      thirdPartyLogisticsPlatform: '第三方物流平台',
    },
    dialog: {
      logisticsCompanyName: '物流商名称',
      businessName: '业务名称',
      businessNameRulesText: '请选择所属物流商',
      businessNameSelect: '请选择业务名称',
      thirdPartyEncoding: '第三方编码',
      thirdPartyPlatform: '第三方平台',
      thirdPartyLogisticsName: '第三方物流名称',
      thirdPartyLogisticsPlatform: '第三方物流平台',
      table: {
        thirdPartyEncodingRulesText: '请输入第三方编码',
        thirdPartyLogisticsNameRulesText: '请输入第三方物流名称',
        thirdPartyLogisticsPlatformRulesText: '请输入第三方物流平台',
        businessNameSelect: '请选择业务名称',
        businessNameRulesText: '请选择物流商名称',
      },
      editLogisticsMapping: '编辑物流映射',
      addLogisticsMapping: '新建物流映射',

    }
  }
};
